<template>
  <div class="down">

    <van-tabs v-model="tabs_active" color="#45B9BC" title-active-color="#45B9BC">
      <van-tab :title="'B级('+member_down1.length+')'">
        <div v-if="member_down1.length > 0">
        <div class="down_list flex" v-for="(down1,index) in member_down1" :key="index">
          <div class="flex">
            <div class="down_list_avater">
              <img :src="down1.avatar?down1.avatar:'/static/img/tech_avater.png'" alt />
            </div>
            <div class="down_list_info">
              <p class="down_list_name">{{down1.nickname}}</p>
              <p class="down_list_mobile"><span>{{down1.mobile?down1.mobile:'暂未绑定手机'}}</span></p>
            </div>
          </div>
          <div class>
            <p class></p>
            <p class="down_list_time">{{down1.agenttime}}</p>
          </div>
        </div>
        </div>
        <div v-else style="text-align:center;font-size:.75rem;color:#999;margin-top:1rem;">暂无记录</div>

      </van-tab>

      <van-tab :title="'C级('+member_down2.length+')'">
        <div v-if="member_down2.length > 0">
        <div class="down_list flex" v-for="(down2,index) in member_down2" :key="index">
          <div class="flex">
            <div class="down_list_avater">
              <img :src="down2.avatar?down2.avatar:'/static/img/tech_avater.png'" alt />
            </div>
            <div class="down_list_info">
              <p class="down_list_name">{{down2.nickname}}</p>
              <p class="down_list_mobile"><span>{{down2.mobile?down2.mobile:'暂未绑定手机'}}</span></p>
            </div>
          </div>
          <div class>
            <p class></p>
            <p class="down_list_time">{{down2.agenttime}}</p>
          </div>
        </div>
        </div>
        <div v-else style="text-align:center;font-size:.75rem;color:#999;margin-top:1rem;">暂无记录</div>
      </van-tab>

    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "down",
  components: {},
  data() {
    return {
      tabs_active: 0,
      total_down1: 11,
      total_down2: 6,
      member_down1:[],
      member_down2:[]
    };
  },
  created() {
    this.get_down();
  },
  methods: {
    get_down(){
      this.axios({
        url: this.api.member.get_down,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member_down1 = res.member_down1;
          this.member_down2 = res.member_down2;
        }
      });
    }
  }
};
</script>
<style scoped>
.down_list {
  background-color: white;
  padding: .9rem 0.75rem .75rem;
  border-bottom:1px solid #eee;
}
.down_list_avater {
  width: 2rem;
  height: 2rem;
}
.down_list_avater img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.down_list_name {
  font-size: 0.8rem;
  color: #484747;
}
.down_list_mobile {
  font-size: 0.6rem;
  color: #838181;
}
.van-tabs--line .van-tabs__wrap{
  padding-bottom:.2rem;
}
.down_list_time{
  font-size:.6rem;
  color:#A9A6A6;
  padding-top:1rem;
}
.down_list_info{
  padding-left:.4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/center/recommend/down.vue